import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';
import css from './HowItWorksPage.module.css';

const HowItWorksPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  // prettier-ignore
  return (
    <StaticPage
      title="How it works"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'HowItWorksPage',
        description: 'How it works',
        name: 'How it works',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>

          <h1 className={css.pageTitle}>How it works</h1>
          
            <h2 className={css.coloredSubTitle}>How it works – for refugees</h2>

            <p>Are you looking for housing, supplies, jobs or something similar? Host4Ukraine is an online platform, where thousands of people from Germany, France, the Netherlands and 40 other countries are offering their help to Ukrainian refugees. </p>
        
            <p>You can find help on Host4Ukraine in two ways: </p>

            <p>
              <strong>Get in contact with a helper: </strong>
              <br/>
              o	Sign up on the website 
              <br/>
              o	Click on “browse listings” and filter search results based on categories 
              <br/>
              o	Select an offer that meets your needs 
              <br/>
              o	Click on the contact button and start writing with the helper immediately over the built-in messenger 
              <br/>
              o	As soon as you are in contact with a helper, you can make further arrangements 
            </p>


            <p>
              <strong>Create a listing to look for help: </strong>
              o	Click on the button “+ Create new listing” and follow the steps <br/>
              o	After you signed up and publish your listing, your call for help will be visible on the website of Host4Ukraine <br/>
              o	Users offering help can respond to your listing directly <br/>
              o	As soon as you are in contact with helpers, you can make further arrangements <br/>
            </p>

            <p>
              <i>
              We recommend you to verify your identity through our verification partner “Veriff”. This will increase the trustworthiness of your user profile and the chances that helpers/refugees reach out to you. Furthermore, we recommend to primarily accept help from verified users. You can recognize a verified user profile by the blue “verified” label next to the respective username. Being in contact with a user, who is not verified, we recommend to ask him to verify himself. It takes under 2 minutes and only requires a live-photo and an official document (e.g. passport, ID card, driver’s license). To start the verification process, you can go to your user profile settings and click on the button “Validate your identity”. To learn more, <a href='/faq'>click here.</a> 
              </i>
            </p>

            <p>
            Please also take a look at our additional safety information. <a href='/safety-center'>Click here</a> for more details.
            </p>

           
            <h2 className={css.coloredSubTitle}>How it works – for helpers (private people and organizations)</h2>

            <p>You can help refugees from Ukraine by offering free accommodation, services, supplies and even jobs! Host4ukraine is an online platform that connects refugees from Ukraine directly to private helpers and help organizations. </p>
        
            <p>You can offer help on our website in two ways: </p>

            <p>
              <strong>Place an offer for help </strong>
              o	Sign up on the website <br/>
              o	Click on “+ Create new listing” and follow the steps <br/>
              o	After you signed up and published your listing, your offer will be visible on the website of Host4Ukraine <br/>
              o	Ukrainian refugees looking for help can respond to your offer directly <br/>
              o	As soon as you are in contact with refugees, you can make further arrangements <br/>
            </p>

            <p>
              <strong>Get in contact with a refugee looking for help </strong>
              o	Click on “Browse listings” and filter search results based on categories<br/>
              o	Select a listing that you can help with <br/>
              o	Click on the contact button and start writing with the refugee instantly <br/>
              o	As soon as you are in contact with a refugee, you can make further arrangements <br/>
            </p>

            <p>
              <i>
              We recommend you to verify your identity through our verification partner “Veriff”. This will increase the trustworthiness of your user profile and the chances that helpers/refugees reach out to you. Furthermore, we recommend to primarily accept help from verified users. You can recognize a verified user profile by the blue “verified” label next to the respective username. Being in contact with a user, who is not verified, we recommend to ask him to verify himself. It takes under 2 minutes and only requires a live-photo and an official document (e.g. passport, ID card, driver’s license). To start the verification process, you can go to your user profile settings and click on the button “Validate your identity”. To learn more, <a href='faq'>click here.</a>  
              </i>
            </p>

            <p>
              <i>
              Organizations can verify themselves by sending us the required documents from an official email address of the organization.
              </i>
            </p>

            <p>
            Please also take a look at our additional safety information. <a href='safety-center'>Click here</a> for more details.
            </p>

        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default HowItWorksPage;
